import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/elements/buttons/Button';
import ResyncShopifyStoreModal
  from 'components/dashboard/integrations/shopify/ResyncShopifyStoreModal';

import './ResyncShopifyStoreButton.css';

const ResyncShopifyStoreButton = props => {
  const [modalOpen, setModalOpen] = useState(false);

  const {
    resyncShopifyStore,
    clearShopifyStoreInfo,
    disabled,
  } = props;

  return (
    <Fragment>
      <Button
        className="resync-shopify-store-button__component"
        onClick={() => { setModalOpen(true); }}
        disabled={disabled}
      >
        re-Sync all products
      </Button>
      <ResyncShopifyStoreModal
        open={modalOpen}
        onClose={() => setModalOpen(false) }
        onResync={() => {
          resyncShopifyStore();
          clearShopifyStoreInfo();
          setModalOpen(false);
        }}
      />
    </Fragment>
  );
};

ResyncShopifyStoreButton.propTypes = {
  resyncShopifyStore: PropTypes.func.isRequired,
  clearShopifyStoreInfo: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

ResyncShopifyStoreButton.defaultProps = {
  disabled: null,
};

export default ResyncShopifyStoreButton;
